import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';

import { Version } from '@core/objects/version';
import { AmsFile } from '@core/objects/ams-file';
import { File } from '@core/objects/file';

@Injectable({
    providedIn: 'root'
})
export class VersionsService {

    constructor(protected url: UrlService, protected http: HttpClient) {}

    /**
     * This could be processed by PreviewService
     * for that we need get only the files of the preview
    */
    getPreview$(version: Version, prefixUrl: string = "") {
        return this.http
        .get(this.url.build(prefixUrl+"/versions/" + version.id + "/preview"));
    }

    getFiles$(version: Version, prefixUrl: string = "") {
        return this.http
        .get(this.url.build(prefixUrl+"/versions/" + version.id + "/files"));
    }


    getAssets$(version: Version, prefixUrl: string = "") {
        return this.http
            .get(this.url.build(prefixUrl + "/versions/" + version.id + "/assets"));
    }

    getMessages$(version: Version, prefixUrl: string = "") {
        return this.http
        .get(this.url.build(prefixUrl+"/versions/" + version.id + "/messages"));
    }

    getFileWithSignatures$(version: Version, file: File, prefixUrl: string = "") {
        //avoid /p for plugin annotatios url
        return this.http
        .get(this.url.build(prefixUrl+"/versions/"+version.id+"/files/"+file.id+'/aesigned/v1').replace('/p/','/'));
    }

    getAssetWithSignatures$(version: Version, file: AmsFile, prefixUrl: string = "") {
        //avoid /p for plugin annotatios url
        return this.http
            .get(this.url.build(prefixUrl + "/versions/" + version.id + "/files/" + file.id + '/aesigned/v1').replace('/p/', '/'));
    }
}
